module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Request for Approval in Exceeding COGS cap\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('div', [_c('p', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("Current Amount : SGD " + _vm._s(_vm.pairing.payoutAmount))])]), _vm._v(" "), _c('div', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "number",
      "placeholder": "Requested Amount",
      "outlined": "",
      "error-messages": _vm.$v.updateData.amount.$error && "Amount is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.amount.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.amount.$touch()
      }
    },
    model: {
      value: (_vm.updateData.amount),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "amount", $$v)
      },
      expression: "updateData.amount"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-textarea', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "Reasons",
      "outlined": "",
      "error-messages": _vm.$v.updateData.reasons.$error && "Reasons is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.reasons.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.reasons.$touch()
      }
    },
    model: {
      value: (_vm.updateData.reasons),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "reasons", $$v)
      },
      expression: "updateData.reasons"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.updateData.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.saveReqApproval()
      }
    }
  }, [_vm._v("Get Approval")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d459c2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/ReqCogsApprovalModal.vue
// module id = 2145
// module chunks = 0